<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>Document Number : {{doc_No}} </p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="row eip-mt-20 eip-ml-xs-10 eip-mr-xs-10">
      <div class="col-xl-12 col-lg-12 col-md-12 p-10">
          <div>
              <kendo-grid [kendoGridBinding]="selectedCCNDetails" [style.maxHeight]="540" [pageable]="false" [sortable]="false" [resizable]="false" [reorderable]="false" [filterable]="false" [selectable]="false" [scrollable]="false" class="k-resizable-grid">
                  <kendo-grid-column field="cCN_No" title="Change Control Note" [width]="100">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.ccnNo}}" eipTooltipPosition="auto">{{dataItem.ccnNo}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="cCN_Description" title="Description" [width]="100">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.ccnDescription}}" eipTooltipPosition="auto">{{dataItem.ccnDescription}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="cCN_Rev_No" [width]="60" title="Revision No">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.ccnRevNo}}" eipTooltipPosition="auto">{{dataItem.ccnRevNo}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="cCN_Date" title="CCN Date" [width]="110">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{ dataItem.ccN_Date | date: 'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{ dataItem.ccN_Date | date: 'dd-MMM-yyyy'}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="man_Hour" [width]="60" title="Man Hours">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.man_Hour}}" eipTooltipPosition="auto">{{dataItem.man_Hour}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="orginator" [width]="100" title="Orginator">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.orginator}}" eipTooltipPosition="auto">{{dataItem.orginator}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="discipline" [width]="80" title="Discipline">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.discipline}} " eipTooltipPosition="auto">{{dataItem.discipline}} </span>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </div>
      </div>
  </div>
</div>
